module.exports = __webpack_public_path__ + "img/box_lng_grey.b7bb3843.png";